import React from "react";
import { Navigate } from "react-router";
import { useAuth } from "../auth/useAuth";

interface ProtectedRouteProps {
  children: React.ReactElement;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const authContext = useAuth();

  if (authContext.isLoading) {
    return <div>Loading...</div>;
  }

  if (!authContext.session) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
